import { useState } from 'react';
import { Button } from '../ui/button';
import { ClipboardList, UserPlus, Vote, Gift, ArrowLeftRight, Tv, CalendarCheck, Bell } from 'lucide-react';
import { LoginHistoryManagement } from './LoginHistoryManagement';
import { VoteHistoryPanel } from './history/VoteHistoryPanel';
import { RewardHistoryPanel } from './history/RewardHistoryPanel';
import { ExchangeHistoryPanel } from './history/ExchangeHistoryPanel';
import { NotificationHistoryPanel } from './history/NotificationHistoryPanel';
import { AdWatchHistory } from './AdWatchHistory';
import { AttendanceManagement } from './AttendanceManagement';

type HistorySubTab = 'login' | 'vote' | 'reward' | 'exchange' | 'adWatch' | 'attendance' | 'notification';

const SUB_TABS: { key: HistorySubTab; label: string; icon: React.ElementType }[] = [
  { key: 'login', label: '가입 내역', icon: UserPlus },
  { key: 'vote', label: '투표 내역', icon: Vote },
  { key: 'reward', label: '리워드 적립', icon: Gift },
  { key: 'exchange', label: '토스 지급', icon: ArrowLeftRight },
  { key: 'adWatch', label: '광고 시청', icon: Tv },
  { key: 'attendance', label: '출석 내역', icon: CalendarCheck },
  { key: 'notification', label: '알림 발송', icon: Bell },
];

export const HistoryManagement = () => {
  const [activeSubTab, setActiveSubTab] = useState<HistorySubTab>('login');

  return (
    <div className="space-y-6">
      {/* 헤더 */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <h2 className="text-lg sm:text-xl font-bold text-gray-900 flex items-center gap-2">
          <ClipboardList className="w-5 h-5" />
          내역관리
        </h2>
      </div>

      {/* 서브탭 */}
      <div className="flex flex-wrap gap-2">
        {SUB_TABS.map(({ key, label, icon: Icon }) => (
          <Button
            key={key}
            variant={activeSubTab === key ? 'default' : 'outline'}
            size="sm"
            onClick={() => setActiveSubTab(key)}
            className="flex items-center gap-1"
          >
            <Icon className="w-3 h-3" />
            {label}
          </Button>
        ))}
      </div>

      {/* 서브탭 컨텐츠 */}
      {activeSubTab === 'login' && <LoginHistoryManagement />}
      {activeSubTab === 'vote' && <VoteHistoryPanel />}
      {activeSubTab === 'reward' && <RewardHistoryPanel />}
      {activeSubTab === 'exchange' && <ExchangeHistoryPanel />}
      {activeSubTab === 'adWatch' && <AdWatchHistory />}
      {activeSubTab === 'attendance' && <AttendanceManagement />}
      {activeSubTab === 'notification' && <NotificationHistoryPanel />}
    </div>
  );
};
